export const SERVICE_OBJECT_PATTERN_NAME = 'pattern:service-object';
